import { EzStandalone } from 'interface/ezoic'

/**
 * Ensures window.ezstandalone and window.ezstandalone.cmd exist.
 * Safe even if sa.min.js loads later, earlier, or gets blocked.
 */
export const ensureEzQueue = (): EzStandalone => {
  const w = window as unknown as { ezstandalone?: EzStandalone }
  w.ezstandalone = w.ezstandalone || {}
  w.ezstandalone.cmd = w.ezstandalone.cmd ? w.ezstandalone.cmd : []

  return w.ezstandalone
}
